import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
const avatarColors = ['bg-crimson', 'bg-cobalt', 'bg-emerald', 'bg-saffron'];
const borderAccents = ['border-l-crimson', 'border-l-cobalt', 'border-l-emerald', 'border-l-saffron'];
export function Leadership() {
  return <section className="w-full bg-midnight px-4 md:px-8 lg:px-16 py-20 md:py-32" data-id="element-198">
      <div className="max-w-7xl mx-auto" data-id="element-199">
        <h2 className="font-heading font-bold text-ivory uppercase text-3xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight mb-16 md:mb-24" data-id="element-200">
          LEADER
          <br data-id="element-201" />
          <span className="text-cobalt" data-id="element-202">SHIP</span>
        </h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-0" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-203">
          <motion.div className={`border-2 border-ivory/20 border-l-4 ${borderAccents[0]} p-6 md:p-10 flex gap-6`} variants={cardVariants} data-id="element-204">
            <div className={`${avatarColors[0]} w-16 h-16 md:w-20 md:h-20 flex-shrink-0 flex items-center justify-center`} data-id="element-205">
              <span className="font-heading font-bold text-ivory text-2xl md:text-3xl" data-id="element-206">
                FS
              </span>
            </div>
            <div data-id="element-207">
              <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl tracking-tight" data-id="element-208">
                Fenella Stavridis
              </h3>
              <span className="font-heading text-crimson text-sm uppercase tracking-widest" data-id="element-209">
                Founder & CEO
              </span>
              <p className="font-body text-ivory/70 text-base mt-4 leading-relaxed" data-id="element-210">
                Former Head of Compliance at a top-5 European iGaming operator.
                15 years navigating the regulatory maze across Mediterranean and
                Nordic markets.
              </p>
            </div>
          </motion.div>

          <motion.div className={`border-2 border-ivory/20 border-l-4 ${borderAccents[1]} p-6 md:p-10 flex gap-6`} variants={cardVariants} data-id="element-211">
            <div className={`${avatarColors[1]} w-16 h-16 md:w-20 md:h-20 flex-shrink-0 flex items-center justify-center`} data-id="element-212">
              <span className="font-heading font-bold text-ivory text-2xl md:text-3xl" data-id="element-213">
                AD
              </span>
            </div>
            <div data-id="element-214">
              <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl tracking-tight" data-id="element-215">
                Alaric Deschênes
              </h3>
              <span className="font-heading text-cobalt text-sm uppercase tracking-widest" data-id="element-216">
                CTO
              </span>
              <p className="font-body text-ivory/70 text-base mt-4 leading-relaxed" data-id="element-217">
                Ex-Google NLP researcher. Built multilingual AI systems
                processing 100M+ translations daily. PhD in Computational
                Linguistics from ETH Zürich.
              </p>
            </div>
          </motion.div>

          <motion.div className={`border-2 border-ivory/20 border-l-4 ${borderAccents[2]} p-6 md:p-10 flex gap-6`} variants={cardVariants} data-id="element-218">
            <div className={`${avatarColors[2]} w-16 h-16 md:w-20 md:h-20 flex-shrink-0 flex items-center justify-center`} data-id="element-219">
              <span className="font-heading font-bold text-ivory text-2xl md:text-3xl" data-id="element-220">
                SO
              </span>
            </div>
            <div data-id="element-221">
              <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl tracking-tight" data-id="element-222">
                Sunniva Okoro
              </h3>
              <span className="font-heading text-emerald text-sm uppercase tracking-widest" data-id="element-223">
                Chief Compliance Officer
              </span>
              <p className="font-body text-ivory/70 text-base mt-4 leading-relaxed" data-id="element-224">
                Former regulatory advisor to three European gaming authorities.
                Specialist in cross-jurisdictional compliance frameworks and
                responsible gaming policy.
              </p>
            </div>
          </motion.div>

          <motion.div className={`border-2 border-ivory/20 border-l-4 ${borderAccents[3]} p-6 md:p-10 flex gap-6`} variants={cardVariants} data-id="element-225">
            <div className={`${avatarColors[3]} w-16 h-16 md:w-20 md:h-20 flex-shrink-0 flex items-center justify-center`} data-id="element-226">
              <span className="font-heading font-bold text-midnight text-2xl md:text-3xl" data-id="element-227">
                LV
              </span>
            </div>
            <div data-id="element-228">
              <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl tracking-tight" data-id="element-229">
                Leander Voss
              </h3>
              <span className="font-heading text-saffron text-sm uppercase tracking-widest" data-id="element-230">
                Head of AI
              </span>
              <p className="font-body text-ivory/70 text-base mt-4 leading-relaxed" data-id="element-231">
                Previously led the machine translation team at a major European
                language technology company. Pioneer in culturally-aware NLP
                models.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}